import SlickSlider from 'react-slick'
import chunk from 'lodash.chunk'
import { branch, renderNothing } from 'recompose'

import { fetchPosts } from 'wordpress/actions'
import { chooseBestFit, extractSizes } from 'wordpress/components'
import { componentSelector } from 'wordpress/selectors'
import { withWordpressLanguage } from 'wordpress/utils'

import 'slick-carousel/slick/slick.scss'
import '../styles/Services.scss'
import { serviceSelector } from '../selectors'

const withService = compose(
    connect(
        createStructuredSelector({
            service: serviceSelector,
        })
    ),
    branch(props => !props.service, renderNothing)
)

const ArrowButton = ({ onClick, role }) => (
    <div className={`arrow ${role}`}>
        <button onClick={onClick} />
    </div>
)

class BackgroundContainer extends Component {
    constructor(props) {
        super(props)

        const { images = {}, src } = this.props

        this.state = {
            sources: { ...images, [src]: true },
            current: src,
        }
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        const { src = false } = newProps
        const { current, sources } = this.state

        if (src) {
            if (!sources[src]) sources[src] = src

            if (current !== src)
                this.setState({
                    sources,
                    current: src,
                })
        }
    }

    render() {
        const { current, sources } = this.state
        const images = Object.keys(sources).map((v, i) => {
            const classNames = current === v ? 'current' : ''
            return <img key={i} src={v} className={classNames} />
        })

        return <div className="background-container">{images}</div>
    }
}

const $ServiceIcon = props => {
    const { index, slideIndex, item, service, selected, onClick } = props

    const activeClass = selected ? 'active' : ''
    const classNames = 'col text-center'
    const onIconClicked = () => onClick(index, slideIndex)

    return (
        <div className={`${classNames} ${activeClass}`} onClick={onIconClicked}>
            <Image className="d-inline-block" image={item.icon} alt={service.name} />
            <span className="clearfix" />

            <h4 className="d-inline-block">{service.name}</h4>
            <span className="selection-marker" />
        </div>
    )
}

const ServiceIcon = withService($ServiceIcon)

class $SlideOut extends Component {
    constructor(props) {
        super(props)

        this.createMarkup = this.createMarkup.bind(this)
        this.onCloseBtnClick = this.onCloseBtnClick.bind(this)
    }

    createMarkup() {
        const { name, description } = this.props.service

        return { __html: `<h2 class="title">${name}</h2> ${description}` }
    }

    onCloseBtnClick() {
        this.props.onCloseBtnClick(this.props)
    }

    render() {
        const { service } = this.props
        const activeClass = service ? 'active' : ''

        return (
            <div className={`slide-out container-fluid ${activeClass}`}>
                {service && (
                    <div className="container">
                        <div className="row">
                            {service.image && (
                                <div className="col text-center image flex-last">
                                    <Image title={service.name} alt={service.name} image={service.image} />
                                </div>
                            )}
                            <div className="col text flex-first" dangerouslySetInnerHTML={this.createMarkup()} />

                            <div className="close-btn" onClick={this.onCloseBtnClick} />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}

const SlideOut = withService($SlideOut)

const Slider = props => {
    const { activeSlide, selectedItemIndex, selectedItemSlideIndex, slides, onServiceClick, onSlideChanged } = props

    const controls = slides.length > 1
    const children = slides.map((slide, index) => {
        const activeClass = selectedItemSlideIndex === index ? 'active' : ''
        const classNames = 'row no-gutters justify-content-center'

        const icons = slide.map((service, i) => {
            const isSelected = index === selectedItemSlideIndex && i === selectedItemIndex

            return (
                <ServiceIcon
                    key={i}
                    index={i}
                    item={service}
                    serviceId={service.service}
                    onClick={onServiceClick}
                    selected={isSelected}
                    slideIndex={index}
                />
            )
        })

        return (
            <div role="container-fluid" key={index}>
                <div className={`${classNames} ${activeClass}`} children={icons} />
            </div>
        )
    })

    return (
        <SlickSlider
            arrows={controls}
            afterChange={onSlideChanged}
            dots={controls}
            initialSlide={activeSlide}
            nextArrow={<ArrowButton role="next" />}
            prevArrow={<ArrowButton role="prev" />}>
            {children}
        </SlickSlider>
    )
}

class Services extends Component {
    constructor(props) {
        super(props)

        this.collectBackgrounds = this.collectBackgrounds.bind(this)
        this.onServiceClick = this.onServiceClick.bind(this)
        this.onSlideChanged = this.onSlideChanged.bind(this)
        this.resetSelection = this.resetSelection.bind(this)

        this.state = {
            activeSlide: 0,
            selectedItemIndex: null,
            selectedItemSlideIndex: null,
        }
    }

    componentDidMount() {
        this.props.fetchPosts('services')
    }

    collectBackgrounds() {
        const sources = {}

        this.props.services.forEach(s => {
            if (s.backgroundImage) sources[chooseBestFit(extractSizes(s.backgroundImage))] = true
        })

        return sources
    }

    onServiceClick(index, slideIndex) {
        this.setState({
            selectedItemIndex: index,
            selectedItemSlideIndex: slideIndex,
        })
    }

    onSlideChanged(slideIndex) {
        this.setState({
            activeSlide: slideIndex,
        })
    }

    resetSelection() {
        this.setState({
            selectedItemIndex: null,
            selectedItemSlideIndex: null,
        })
    }

    render() {
        const { activeSlide, selectedItemIndex, selectedItemSlideIndex } = this.state
        const { itemsPerSlide } = this.props
        const { title, background, buttonAction, buttonLabel, page, url, services = [] } = this.props

        if (!services.length) return null

        const slides = chunk(services, itemsPerSlide)

        const selectedItem = selectedItemIndex === null ? null : slides[selectedItemSlideIndex][selectedItemIndex]
        const selectionClass = selectedItem ? 'item-selected' : ''

        const backgroundImage = chooseBestFit(
            extractSizes(selectedItem && selectedItem.backgroundImage ? selectedItem.backgroundImage : background)
        )
        const serviceBackgrounds = this.collectBackgrounds()

        const viewAllBtn = label => {
            const classNames = 'btn btn-success d-block'

            return buttonAction === 'page' ? (
                <Link className={classNames} to={page} title={label}>
                    {label}
                </Link>
            ) : (
                <a target="__blank" className={classNames} href={url} title={label}>
                    {label}
                </a>
            )
        }

        return (
            <div>
                <div className={`container-fluid p-0 selection ${selectionClass}`} id="featured-services">
                    <BackgroundContainer src={backgroundImage} images={serviceBackgrounds} />

                    <div className="container" id="featured-services-slider">
                        <div className="row no-gutters">
                            <div className="header col text-center clearfix">
                                <h1>{title}</h1>
                                {viewAllBtn(buttonLabel)}
                            </div>
                        </div>

                        <Slider
                            activeSlide={activeSlide}
                            selectedItemIndex={selectedItemIndex}
                            selectedItemSlideIndex={selectedItemSlideIndex}
                            slides={slides}
                            onServiceClick={this.onServiceClick}
                            onSlideChanged={this.onSlideChanged}
                        />
                    </div>
                </div>
                <SlideOut
                    item={selectedItem}
                    serviceId={selectedItem ? selectedItem.service : null}
                    onCloseBtnClick={this.resetSelection}
                />
            </div>
        )
    }
}

export default compose(withWordpressLanguage, connect(componentSelector('services'), { fetchPosts }))(Services)
